// Writes a table's export cells to an .xlsx and downloads it. exceljs is
// big, so it's only fetched the first time someone exports.
const exportTableExcel = async ({
  cells,
  fileName,
  sheetName = 'Export',
}: {
  cells: DataTable.ExportCells;
  fileName: string;
  sheetName?: string;
}) => {
  const { default: ExcelJS } = await import('exceljs');
  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet(sheetName);

  cells.headerRows.forEach((headerRow) => {
    sheet.addRow(headerRow).font = { bold: true };
  });
  sheet.addRows(cells.rows);
  sheet.columns.forEach((column, index) => {
    const widest = Math.max(
      ...[...cells.headerRows, ...cells.rows].map(
        (row) => (row[index] ?? '').length,
      ),
    );
    column.width = Math.min(Math.max(widest + 2, 8), 60);
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${fileName}.xlsx`);
  link.click();
  URL.revokeObjectURL(url);
};

export default exportTableExcel;
